module.exports = __webpack_public_path__ + "img/ih.ba6466ad.svg";